import { render, staticRenderFns } from "./PatientDeviceSection.vue?vue&type=template&id=3859bdad&scoped=true&"
import script from "./PatientDeviceSection.vue?vue&type=script&lang=js&"
export * from "./PatientDeviceSection.vue?vue&type=script&lang=js&"
import style0 from "./PatientDeviceSection.vue?vue&type=style&index=0&id=3859bdad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3859bdad",
  null
  
)

export default component.exports